import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const EdicionProduccionApi = () => {
    const [cargando, setCargando] = useState(false);

    const agregarOrdenProduccion = (idProduccion, orden) => {
        try {
            setCargando(true);
            const response = api.post(
                `produccion_v2/${idProduccion}/agregar_orden_produccion`,
                orden,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const eliminarOrdenProduccion = (idOrden) => {
        try {
            setCargando(true);
            const response = api.eliminar(
                `produccion_v2/eliminar_orden_produccion/${idOrden}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarKgOrdenProduccion = (idOrden, kgAProducir) => {
        try {
            setCargando(true);
            const response = api.patch(
                `produccion_v2/actualizar_kg_orden_produccion/${idOrden}`,
                { kg_a_producir: kgAProducir },
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarProduccion = async (id, data) => {
        try {
            setCargando(true);
            const response = await api.put(`produccion_v2/${id}`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getDetalleProduccion = async (id) => {
        try {
            setCargando(true);

            const response = await api.get(`produccion_v2/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        agregarOrdenProduccion,
        eliminarOrdenProduccion,
        actualizarKgOrdenProduccion,
        actualizarProduccion,
        getDetalleProduccion,

        cargando,
    };
};
